// @ts-ignore
import messages from '@/lang/index';

export const PROJ_PFX = 'lsn_'

// CONFIG PROPS
export const CONF_BASE_URL = 'BASE_URL'
export const CONF_WEBUI_LINK = 'WEBUI_LINK'
export const CONF_CLIENT_SITE_LINK = 'CLIENT_SITE_LINK'
export const CONF_CLEINT_LOGO_PREFIX = 'CLEINT_LOGO_PREFIX'
export const CONF_IDLE_TIME = 'IDLE_TIME'
export const CONF_TG_BOT_NAME = 'TG_BOT_NAME'
export const CONF_VB_BOT_NAME = 'VB_BOT_NAME'
export const CONF_VK_COMMUNITY_LINK = 'VK_COMMUNITY_LINK'
export const CONF_WS_URL = 'WS_URL'
export const STUDENT_INFO_SHOW_PASSWORD = 'STUDENT_INFO_SHOW_PASSWORD'
export const STUDENT_LIST_SORT = 'STUDENT_LIST_SORT'
export const LANG = 'LANG'
export const AVAILABLE_LANGS = 'AVAILABLE_LANGS'
export const PRIVACY_POLICY = 'PRIVACY_POLICY'
export const HIDE_SIDEBAR_LINKS = 'HIDE_SIDEBAR_LINKS'

export const CONF_LOGIN_INPUT_LABEL = 'LOGIN_INPUT_LABEL'
export const CONF_GET_ACCOUNT_TEXT = 'GET_ACCOUNT_TEXT'
export const CONF_FORGET_PASSWORD_TEXT = 'FORGET_PASSWORD_TEXT'
export const CONF_FORGET_PASSWORD_REDIRECT = 'FORGET_PASSWORD_REDIRECT'

// Config required props
export const CONF_REQ_PROPS = [
  CONF_BASE_URL,
  CONF_WEBUI_LINK,
  CONF_CLIENT_SITE_LINK,
  CONF_CLEINT_LOGO_PREFIX
]

// User Roles
export const USER_ROLE_ADMIN = 'ADMIN';
export const USER_ROLE_ADMIN_LABEL = messages.labels.user_role_admin_label;
export const USER_ROLE_MAILING = 'MAILING';
export const USER_ROLE_MAILING_LABEL = messages.labels.user_role_mailing_label;
export const USER_ROLE_STATS = 'STATS';
export const USER_ROLE_STATS_LABEL = messages.labels.user_role_stats_label;
export const USER_ROLE_STUD = 'STUD';
export const USER_ROLE_STUD_LABEL = messages.labels.user_role_stud_label;
export const USER_ROLE_WIKI = 'WIKI';
export const USER_ROLE_WIKI_LABEL = messages.labels.user_role_wiki_label;
export const USER_ROLE_STUDAUTH = 'STUDAUTH';
export const USER_ROLE_STUDAUTH_LABEL = messages.labels.user_role_studauth_label;
export const USER_ROLE_CHAT = 'CHAT';
export const USER_ROLE_CHAT_LABEL = messages.labels.user_role_chat_label;

export const USER_ROLES_DICT = {
  [USER_ROLE_ADMIN]: USER_ROLE_ADMIN_LABEL,
  [USER_ROLE_MAILING]: USER_ROLE_MAILING_LABEL,
  [USER_ROLE_STATS]: USER_ROLE_STATS_LABEL,
  [USER_ROLE_STUD]: USER_ROLE_STUD_LABEL,
  [USER_ROLE_WIKI]: USER_ROLE_WIKI_LABEL,
  [USER_ROLE_STUDAUTH]: USER_ROLE_STUDAUTH_LABEL,
  [USER_ROLE_CHAT]: USER_ROLE_ADMIN_LABEL,
}

// User Statuses
export const USER_STATUS_ACTIVE = 'ACTIVE';
export const USER_STATUS_ACTIVE_LABEL = messages.labels.status_active;
export const USER_STATUS_CLOSED = 'CLOSED';
export const USER_STATUS_CLOSED_LABEL = messages.labels.status_closed;

export const USER_STATUSES_DICT = {
  [USER_STATUS_ACTIVE]: USER_STATUS_ACTIVE_LABEL,
  [USER_STATUS_CLOSED]: USER_STATUS_CLOSED_LABEL
}

// Mailing Statuses
export const MAILING_STATUS_DRAFT = 'DRAFT'
export const MAILING_STATUS_READY = 'READY'
export const MAILING_STATUS_PROGRESS = 'PROGRESS'
export const MAILING_STATUS_COMPLETED = 'COMPLETED'
export const MAILING_STATUS_CANCELED = 'CANCELED'

export const MAILING_STATUS_BEFORE_PROGRESS = 'BEFORE_PROGRESS' // no in server

export const MAILING_TYPE_TEXT = 'TEXT'
export const MAILING_TYPE_NEWS = 'NEWS'

// Mailing vote types
export const VOTE_TYPE_YESNO = 'YESNO'
export const VOTE_TYPE_STARS5 = 'STARS5'
export const VOTE_TYPE_LIKE = 'LIKE'

// MSGRS
export const MSGR_VK = 'vk'
export const MSGR_TG = 'tg'
export const MSGR_VB = 'vb'
export const MSGR_LDP = 'ldp'
export const MSGRS_LIST = [MSGR_VK, MSGR_TG, MSGR_VB]

// Polls Statuses
export const POLL_STATUS_OPEN = 'OPEN'
export const POLL_STATUS_FINISHED = 'FINISHED'

// MESSAGES
export const MESSAGE_TYPE_STAFFUSER = 'STAFFUSER'
export const MESSAGE_TYPE_LSNUSER = 'LSNUSER'
export const MESSAGE_TYPE_MAILING = 'MAILING'
export const MESSAGE_TYPE_POLL = 'POLL'
export const MESSAGE_TYPE_NOTIFY = 'NOTIFY'
export const MESSAGE_TYPE_MANAGER = 'MANAGER'
export const MESSAGE_MSGR_STATUS_OK = 'OK'
export const MESSAGE_MSGR_STATUS_ERR = 'ERR'
export const MESSAGE_VOTE_TYPE_YESNO = 'YESNO'
export const MESSAGE_VOTE_TYPE_STARS5 = 'STARS5'
export const MESSAGE_VOTE_TYPE_LIKE = 'LIKE'
export const MESSAGE_VOTE_RESULT_YES = 'yes'
export const MESSAGE_VOTE_RESULT_NO = 'no'
export const MESSAGE_VOTE_RESULT_1 = '1'
export const MESSAGE_VOTE_RESULT_2 = '2'
export const MESSAGE_VOTE_RESULT_3 = '3'
export const MESSAGE_VOTE_RESULT_4 = '4'
export const MESSAGE_VOTE_RESULT_5 = '5'
export const MESSAGE_VOTE_RESULT_LIKE = 'like'

// STUDENTS FILTERS VALS DICTIONARY
import {acs, numToStr, strToNum} from '@/lib/array'
export const STUD_FIELDS_VALS: {[key: string]: {label: string, dict?: {[key: string]: string}, sort?: any[]}} = {
  for_all: {label: messages.common.student_field_vals.for_all, sort: [acs]},
  depart: {label: messages.common.student_field_vals.depart, sort: [acs]},
  faculty: {label: messages.common.student_field_vals.faculty, sort: [acs]},
  course: {label: messages.common.student_field_vals.course, sort: [strToNum, acs, numToStr]},
  group: {label: messages.common.student_field_vals.group, sort: [acs]},
  form: {label: messages.common.student_field_vals.form, sort: [acs]},
  filial: {label: messages.common.student_field_vals.filial, sort: [acs]},
  financing: {label: messages.common.student_field_vals.financing},
  // program: {label: messages.common.student_field_vals.program, sort: [acs]},
  // term: {label: messages.common.student_field_vals.term, sort: [acs]},
  state: {label: messages.common.student_field_vals.state, sort: [acs]},
  half_year: {label: messages.common.student_field_vals.half_year, sort: [acs]},
  semester: {label: messages.common.student_field_vals.semester, sort: [acs]},
  specialty: {label: messages.common.student_field_vals.specialty, sort: [acs]},
  gender: {label: messages.common.student_field_vals.gender, sort: [acs]},
  foreigner: {label: messages.common.student_field_vals.foreigner, sort: [acs]},
  need_hostel: {label: messages.common.student_field_vals.need_hostel, sort: [acs]},
  status: {label: messages.common.student_field_vals.status, sort: [acs]},
  edu_honors: {label: messages.common.student_field_vals.edu_honors, sort: [acs]},
  target_enrollment: {label: messages.common.student_field_vals.target_enrollment, sort: [acs]},
  target_organization: {label: messages.common.student_field_vals.target_organization, sort: [acs]},
  plan_code: {label: messages.common.student_field_vals.plan_code, sort: [acs]},
  plan_cname: {label: messages.common.student_field_vals.plan_cname, sort: [acs]},
  type_edu: {label: messages.common.student_field_vals.type_edu, sort: [acs]},
  speciality: {label: messages.common.student_field_vals.speciality, sort: [acs]},
  citizen: {label: messages.common.student_field_vals.citizen, sort: [acs]},
  hostel: {label: messages.common.student_field_vals.hostel, sort: [acs]},
  prog_asp: {label: messages.common.student_field_vals.prog_asp, sort: [acs]},
  prog_mag: {label: messages.common.student_field_vals.prog_mag, sort: [acs]},
  qualif: {label: messages.common.student_field_vals.qualif, sort: [acs]},
  competition: {label: messages.common.student_field_vals.competition, sort: [acs]},
  msgrs: {label: messages.common.student_field_vals.msgrs, dict: {
    [MSGR_VK]: messages.common.socials.vk,
    [MSGR_TG]: messages.common.socials.tg,
    [MSGR_VB]: messages.common.socials.vb,
  }}
}

export const STUFF_FIELDS_VALS: {[key: string]: {label: string, dict?: {[key: string]: string}, sort?: any[]}} = {
  msgrs: {label: messages.common.student_field_vals.msgrs, dict: {
    [MSGR_VK]: messages.common.socials.vk,
    [MSGR_TG]: messages.common.socials.tg,
    [MSGR_VB]: messages.common.socials.vb,
  }},
  orgs_notes: {label: messages.labels.position, sort: [acs]},
  roles: {label: messages.labels.status_in_system, dict: USER_ROLES_DICT},
  statuses: {label: messages.labels.status_in_system, dict: USER_STATUSES_DICT},
  orgs: {label: messages.labels.organizations}
}

// ERRORS CODES
export const E_SESS_INACTIVE = 'E_SESS_INACTIVE'
export const E_SESS = 'E_SESS'
export const E_ACCESS = 'E_ACCESS'
export const E_PASSWORD = 'E_PASSWORD'
export const E_PARAM = 'E_PARAM'
export const E_STATUS = 'E_STATUS'
export const E_LOGIN = 'E_LOGIN'

// Errors types
export const E_TYPE_REQUESR = 'RequestError'

// NOTIFY
export const NOTIFY_TYPE_READ = 'NOTIFY_READ'
export const NOTIFY_TYPE_SELFTEST = 'SELFTEST'

// SCHEDULE
export const SCHEDULE_GROUP_NAME = 'Учебная группа' // name get by backend

// API
export const API = {
  auth: {
    sess: 'auth/sess',
    login: 'cproc/auth/login',
    logout: 'auth/logout',
    refresh: 'cproc/auth/refresh'
  },
  user: {
    me: 'user/me',
    password: 'user/password',
    userUpdate: 'user/update',
    upicRemove: 'user/upic_remove',
    userProfileUpdate: 'cproc/staff/profile/update'
  },
  admin: {
    createUser: 'admin/create_user',
    authLookup: 'admin/auth_lookup',
    getUser: 'admin/get_user',
    findUsers: 'admin/find_users',
    updateUser: 'admin/update_user',
    setPassword: 'admin/user_password',
    setStatus: 'admin/user_status',
    setRoles: 'admin/user_roles',
    upicRemove: 'admin/upic_remove',
    removeUser: 'admin/remove_user',
    msgrUnbind: '/cproc/admin/user/msgr/unbind'
  },
  files: {
    upic: {
      upload: '/files/upic/upload'
    }
  },
  orgs: {
    getOrg: 'org/get',
    byParent: 'org/by_parent',
    orgList: 'org/list',
    orgCreate: 'org/create',
    orgUpdate: 'org/update',
    setParent: 'org/set_parent',
    orgRemove: 'org/remove'
  },
  stud: {
    byId: 'stud/by_id',
    fieldVals: 'stud/field_vals',
    find: 'stud/find',
    getPassword: 'stud/get_password',
    resetPassword: 'stud/reset_password',
    dropMsgrs: 'stud/drop_msgrs',
    passwords: 'stud/passwords'
  },
  mailing: {
    get: 'mailing/get',
    find: 'mailing/find',
    create: 'mailing/create',
    update: 'mailing/update',
    setReady: 'mailing/set_ready',
    setDraft: 'mailing/set_draft',
    delete: 'mailing/delete',
    rcptFind: 'mailing/rcpt_find',
    rcptAddIds: 'mailing/rcpt_add_ids',
    rcptAddFilter: 'mailing/rcpt_add_filter',
    rcptRemoveFilter: 'mailing/rcpt_remove_filter',
    rcptRemoveIds: 'mailing/rcpt_remove_ids',
    cancel: 'mailing/cancel',
    resend: 'mailing/resend',
    send_now: 'mailing/send_now'
  },
  poll: {
    get: 'poll/get',
    find: 'poll/find',
    create: 'poll/create',
    update: 'poll/update',
    delete: 'poll/delete',
    rcptFind: 'poll/rcpt_find',
    rcptAddIds: 'poll/rcpt_add_ids',
    rcptAddFilter: 'poll/rcpt_add_filter',
    rcptRemoveFilter: 'poll/rcpt_remove_filter',
    rcptRemoveIds: 'poll/rcpt_remove_ids',
    cancel: 'poll/cancel',
    resend: 'poll/resend',
    resultsXlsx: 'poll/results_xlsx'
  },
  wiki: {
    nodeGet: 'wiki/node_get',
    nodeList: 'wiki/node_list',
    nodeCreate: 'wiki/node_create',
    nodeUpdate: 'wiki/node_update',
    nodeParent: 'wiki/node_parent',
    nodeDelete: 'wiki/node_delete',
    pageList: 'wiki/page_list',
    pageGet: 'wiki/page_get',
    pageCreate: 'wiki/page_create',
    pageUpdate: 'wiki/page_update',
    pageParent: 'wiki/page_parent',
    pageDelete: 'wiki/page_delete'
  },
  crop: {
    entery: '/cproc',
    postMessage: 'chat.staff/post_message',
    listMessages: 'chat.staff/list_messages',
    getMessages: 'chat.staff/get_messages',
    logExternal: 'cproc/log_external'
  },
  notify: {
    getList: 'cproc/notify/get-list',
    markRead: 'cproc/notify/mark-read',
    selfTest: 'cproc/notify/selftest',
  },
  msgr: {
    getCode: 'cproc/user/msgr/get-code',
    unbind: 'cproc/user/msgr/unbind'
  }
}